import { useFlagsmithLoading } from 'flagsmith/react';

import { FellowsCornerPage } from '@/components/fellows-corner/FellowsCornerPage';
import { Spinner } from '@/components/ui/spinner';
import { View } from '@/components/ui/view';

/**
 * Fellows Corner is reachable by direct link, so the flag is enforced on the route rather
 * than only on the nav link and the promo banner. That enforcement now lives in the secure
 * group's layout, which drops this route's name from the navigator when the flag is off; its
 * guard carries the reasoning for why an unresolved flag closes the feature rather than
 * opening it.
 *
 * The spinner stays, and is the half the guard cannot do. The guard is deliberately open
 * while flags are still loading, because treating silence as "off" would bounce the very
 * readers the flag is on for. This route is therefore declared and mounted during that
 * window, and without the spinner it would render the page to someone the flag may be off
 * for and then yank it away.
 *
 * `undefined` is before the client has said anything, not after. Reading it as settled sent
 * a reload to the directory, since the flag still held its default at that point and the
 * default is off. Initialization carries its own timeout, so silence resolves rather than
 * hanging here.
 */
export default function FellowsCornerRoute() {
  const loadingState = useFlagsmithLoading();

  const haveFlagsSettled = loadingState != null && !loadingState.isLoading;

  if (!haveFlagsSettled) {
    return (
      <View className="flex-1 items-center justify-center">
        <Spinner />
      </View>
    );
  }

  return <FellowsCornerPage />;
}
